module.exports = __webpack_public_path__ + "img/clickhouse.ce1d63a9.svg";